module.exports = __webpack_public_path__ + "static/media/Logo_Home.d674dda6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo_Home.svg
// module id = 459
// module chunks = 0